export function secondsToTimestamp(seconds: number): string {
    return new Date(seconds * 1000).toISOString().substr(14, 5)
}

export function timestampToSeconds(timestamp: string): number {
    const validationResult = validateTimestamp(timestamp)

    if (validationResult.isValid === false) {
        throw Error(`Invalid timestamp ${timestamp}`)
    }

    const parts = {
        minutes: 0,
        seconds: 0,
        millis: 0
    }

    if (validationResult.format === "MMSS") {
        parts.minutes = parseInt(timestamp.substr(0, 2))
        parts.seconds = parseInt(timestamp.substr(2, 2))
    }

    if (validationResult.format === "MM:SS") {
        parts.minutes = parseInt(timestamp.substr(0, 2))
        parts.seconds = parseInt(timestamp.substr(3, 2))
    }

    if (validationResult.format === "HH:MM:SS.SSS") {
        parts.minutes = parseInt(timestamp.substr(3, 2))
        parts.seconds = parseInt(timestamp.substr(6, 2))
        parts.millis = parseInt(timestamp.substr(9, 3)) / 1000
    }

    if (parts.seconds > 59) {
        throw Error(`Invalid timestamp ${timestamp}`)
    }

    return (parts.minutes * 60) + (Math.round(parts.seconds + parts.millis))
}

function validateTimestamp(raw: string): { isValid: boolean; format?: TimestampFormat } {
    if (raw.length < 4) {
        return {
            isValid: false
        }
    }

    if (raw.match(TIME_FORMATS_REGEXP.HH_MM_SS_SSS)) {
        return {
            isValid: true,
            format: 'HH:MM:SS.SSS'
        }
    }

    if (raw.match(TIME_FORMATS_REGEXP.MM_SS)) {
        return {
            isValid: true,
            format: 'MM:SS'
        }
    }

    if (raw.match(TIME_FORMATS_REGEXP.MMSS)) {
        return {
            isValid: true,
            format: 'MMSS'
        }
    }

    return {
        isValid: false
    }
}

export const TIME_FORMATS_REGEXP = {
    MMSS: /\b\d{4}\b/,
    MM_SS: /\b\d{2}:\d{2}\b/,
    HH_MM_SS_SSS: /\b\d{2}:\d{2}:\d{2}.\d{3}\b/
}

type TimestampFormat = "MMSS" | "MM:SS" | "HH:MM:SS.SSS"